import { render, staticRenderFns } from "./PaperDetails.vue?vue&type=template&id=13546016&scoped=true&"
import script from "./PaperDetails.vue?vue&type=script&lang=js&"
export * from "./PaperDetails.vue?vue&type=script&lang=js&"
import style0 from "./PaperDetails.vue?vue&type=style&index=0&id=13546016&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13546016",
  null
  
)

export default component.exports